// This file is now deprecated - use the AuthContext instead
// Keeping for backward compatibility during transition

import { useAuth } from '@/contexts/AuthContext';

export const useAdminStatus = () => {
  const { isAdmin, loading } = useAuth();
  return { isAdmin, loading };
};